<div class="toggle">
  <input
    type="checkbox"
    [id]="id"
    (change)="toggle()"
    [checked]="checked"
    class="toggle__checkbox toggle__area"
    />

    <span class="toggle__custom-input toggle__area">
      <span class="toggle__track toggle__area" [@toggleTrack]="checked"></span>
      <span class="toggle__circle" [@toggleCircle]="checked"></span>
    </span>

    @if (label) {
      <label
        [for]="id"
        class="toggle__label"
        >
        {{ label }}
      </label>
    }
  </div>